<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">收银系统pc端菜单管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        
        <el-radio-group v-model="tabPosition" @change="tabChange" style="margin-bottom: 30px;">
            <el-radio-button label="1">一级</el-radio-button>
            <el-radio-button label="2">二级</el-radio-button>
        </el-radio-group>
        <el-form :inline="true" :model="formInline" label-width="10px" class="user-search">
            <el-form-item label=" ">
                <el-button type="primary" @click="addBanner">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column  prop="url" label="图片" width="300">
            <template slot-scope="scope" align="center">
                <el-image
                style="width: 200px; height: 100px"
                class="img_inner"
                :src="scope.row.file"
                fit="fit"></el-image>
            </template>
        </el-table-column>
        <el-table-column  prop="remark" label="文案" >
        </el-table-column>
        <el-table-column  prop="fatherName" v-if="tabPosition == 2" label="所属上级" >
        </el-table-column>
        <el-table-column  prop="linkType" label="跳转方式" >
            <template slot-scope="scope" align="center">
                <span v-if="scope.row.linkType == 3">内部路径</span>
                <span v-if="scope.row.linkType == 6">弹窗</span>
            </template>
        </el-table-column>
        <el-table-column  prop="linkType" label="菜单类型" >
            <template slot-scope="scope" align="center">
                <span v-if="scope.row.barflag == 3">酒吧系统</span>
                <span v-if="scope.row.barflag == 2">共用</span>
                <span v-if="scope.row.barflag == 1">收银系统</span>
            </template>
        </el-table-column>
        <el-table-column  prop="num" label="排序" >
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="link" label="链接" width="300">
        </el-table-column>
        <el-table-column  prop="status" label="状态" >
            <template slot-scope="scope" align="center">
                <span v-if="scope.row.status == 1">上架</span>
                <span v-if="scope.row.status == 0">下架</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="300">
            <template slot-scope="scope">
            <el-button size="mini" v-preventReClick @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" v-preventReClick type="success" v-if="scope.row.status == 0" @click="updateInfomercial(scope.row , 1)">上架</el-button>
            <el-button size="mini" v-preventReClick type="danger" v-if="scope.row.status == 1" @click="updateInfomercial(scope.row , 0)">下架</el-button>
            <el-button size="mini" v-preventReClick type="danger" @click="delInfomercial(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="按钮类型" prop="type">
                    <el-radio-group v-model="editForm.type" @input="typeInput">
                        <el-radio label="1">一级</el-radio>
                        <el-radio label="2">二级</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择一级" v-if="editForm.type == 2" prop="fatherId" >
                    <el-select v-model="editForm.fatherId" placeholder="请选择">
                        <el-option
                        v-for="item in fatherList"
                        :key="item.id"
                        :label="item.remark"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                        :http-request="handleChange"
                        :file-list="fileList"
                        accept=".jpg , .png ,"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="文案" prop="remark">
                <el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="跳转方式" prop="linkType">
                    <el-radio-group v-model="editForm.linkType">
                        <el-radio :label="3">内部路径</el-radio>
                        <el-radio :label="6">弹窗</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="菜单类型" prop="barflag">
                    <el-radio-group v-model="editForm.barflag">
                        <el-radio :label="2">共用</el-radio>
                        <el-radio :label="1">收银系统</el-radio>
                        <el-radio :label="3">酒吧系统</el-radio>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item label="链接路径">
                <el-input size="small" v-model="editForm.link" auto-complete="off" placeholder="请输入链接"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="num">
                <el-input size="small" v-model="editForm.num" auto-complete="off" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="editForm.status" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 编辑 -->
        <el-dialog :visible.sync="editFlag" width="40%" @click="closeDialog">
            <el-form label-width="120px" :model="editSubForm" :rules="rules" ref="editSubForm">
                <el-form-item label="按钮类型" prop="type">
                    <el-radio-group v-model="editSubForm.type" disabled @input="editTypeInput">
                        <el-radio label="1">一级</el-radio>
                        <el-radio label="2">二级</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择一级" v-if="editSubForm.type == 2" prop="fatherId" >
                    <el-select v-model="editSubForm.fatherId" placeholder="请选择">
                        <el-option
                        v-for="item in fatherList"
                        :key="item.id"
                        :label="item.remark"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片">
                    <el-image
                    style="width: 200px; height: 100px"
                    :src="editSubForm.file"
                    fit="fit"></el-image>
                </el-form-item>
                <el-form-item label="重新上传">
                    <el-upload
                        :http-request="handleChange"
                        :file-list="fileList"
                        accept=".jpg , .png , .mp4"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                    </el-upload>
                </el-form-item>
                <el-form-item label="文案" prop="remark">
                <el-input size="small" v-model="editSubForm.remark" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="跳转方式" prop="linkType">
                    <el-radio-group v-model="editSubForm.linkType">
                        <el-radio :label="3">内部路径</el-radio>
                        <el-radio :label="6">弹窗</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="菜单类型" prop="barflag">
                    <el-radio-group v-model="editSubForm.barflag">
                        <el-radio :label="2">共用</el-radio>
                        <el-radio :label="1">收银系统</el-radio>
                        <el-radio :label="3">酒吧系统</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="链接路径">
                <el-input size="small" v-model="editSubForm.link" auto-complete="off" placeholder="请输入链接"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="num">
                <el-input size="small" v-model="editSubForm.num" auto-complete="off" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="editSubForm.status" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="editSubmitForm('editSubForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 视频 -->
        <el-dialog :visible.sync="videoFlag" width="45%" @click="closeDialog">
            <VideoPlay
                v-show="true"
                :videoUrl="videoUrl"
                :videoCover="videoCover"
                width="100%"
                :height="450"
                :autoplay="true"
                :controls="true"
                :loop="false"
                :muted="false"
                preload="auto"
                :showPlay="true"
                :playWidth="96"
                zoom="cotain"
            />
        </el-dialog>
</div>
</template>
<script>
import VideoPlay from '../../video.vue'
import Pagination from '../../../components/Pagination'
import { createInfomercial , 
    loadInfomercialList , 
    loadCustomerList ,
    updateInfomercial,
    loadInfomercialListNoPage,
    delInfomercial } from '../../../api/userMG'
export default {
    data(){
        return{
            id:'',
            loading:false,
            fatherList:[],
            tabPosition:'1',
            typeNum:'',
            videoFlag:false,
            videoUrl:'',
            rules: {
                link : [
                { required: true, message: '请输入链接', trigger: 'blur' }
                ],
                remark : [
                { required: true, message: '请输入', trigger: 'blur' }
                ],
                linkType : [
                { required: true, message: '请选择跳转方式', trigger: 'blur' }
                ],
                type : [
                { required: true, message: '请选择按钮类型', trigger: 'blur' }
                ],
                fatherId: [
                { required: true, message: '请选择一级', trigger: 'blur' }
                ],
                num: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    {
                        pattern: /^\+?[1-9][0-9]*$/,
                        required: true,
                        message: '请输入正确序号',
                        trigger: 'blur'
                    }
                ],
            },
            editSubForm:{},
            editFlag:false,
            fileList:[],
            videoFileList:[],
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            options2:[{
                value: "1",
                label: '图片'
                }, {
                value: "2",
                label: '视频'
                },],
            editForm:{
                type:'',
                link:'',
                num:'',
                remark:'',
                status:'1',
                fatherId:'',
                barflag:2
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        Pagination,
        VideoPlay
    },
    created(){
        this.getdata()
    },
    methods:{
        videoCover(){

        },
        typeInput(e){
            console.log(e)
            if(e == 1){
                this.editForm.fatherId = ''
            }else {
                loadInfomercialListNoPage({
                    position:7,
                    type:1
                }).then(res=>{
                    this.fatherList =  res.pageInfo
                })
            }
        },
        editTypeInput(e){
            if(e == 1){
                this.editSubForm.fatherId = ''
            }else {
                loadInfomercialListNoPage({
                    position:7,
                    id:this.id,
                    type:1
                }).then(res=>{
                    this.fatherList =  res.pageInfo
                })
            }
        },
        videoClick(row){
                this.videoUrl = row.file
                this.videoFlag = true
        },  
        handleEdit(index , row){
            this.editFlag = true
            this.id = row.id
            row.status = String(row.status)
            row.type = String(row.type)
            if(row.type == 2){
                this.editTypeInput(2)
            }else {
                row.fatherId = ''
            }
            this.editSubForm = JSON.parse(JSON.stringify(row))
            this.typeNum = row.type
            
        },
        editSubmitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    let data = this.editSubForm
                    let formData = new FormData()
                    formData.append('uplaodFile' , this.fileList[0])
                    formData.append('position' , data.position)
                    formData.append('type' ,data.type)
                    formData.append('link' ,data.link)
                    formData.append('num' ,data.num)
                    formData.append('remark' ,data.remark)
                    formData.append('status' ,data.status)
                    formData.append('id' ,data.id)
                    formData.append('fatherId' ,data.fatherId)
                    formData.append('linkType' ,data.linkType)
                    formData.append('barflag' ,data.barflag)
                    this.$axios({
                        method: "POST",
                        url: "/yunyue-houtai/admin/updateInfomercial",
                        headers: {
                        "Content-Type": "multipart/form-data",
                        token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                        },
                        data: formData,
                    }).then(res => {
                        if (res.data.success) {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            })
                            this.editFlag = false
                            this.fileList = []
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.data.messages
                            })
                        }
                    }).catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                } else {
                    return false
                }
            })
        },
        // 新建提交
        submitForm(editData){
            console.log(this.editForm)
            console.log(this.fileList)
            console.log(this.videoFileList)
            this.$refs[editData].validate(valid => {
                if (valid) {
                    let data = this.editForm
                    data.position = 0
                    let formData = new FormData()
                    if(this.fileList[0] == undefined){
                        this.$message.error('上传图片')
                        return
                    }
                    formData.append('uplaodFile' , this.fileList[0])
                    formData.append('position' , 7)
                    formData.append('type' ,data.type)
                    formData.append('link' ,data.link)
                    formData.append('num' ,data.num)
                    formData.append('remark' ,data.remark)
                    formData.append('status' ,data.status)
                    formData.append('linkType' ,data.linkType)
                    formData.append('fatherId' ,data.fatherId)
                    formData.append('barflag' ,data.barflag)
                    this.$axios({
                        method: "POST",
                        url: "/yunyue-houtai/admin/createInfomercial",
                        headers: {
                        "Content-Type": "multipart/form-data",
                        token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                        },
                        data: formData,
                    }).then(res=>{
                        console.log(res)
                        if(res.data.success == true){
                            this.$message.success('创建成功')
                            this.editFormVisible = false
                            this.getdata()
                            this.editForm = {
                                status:'1'
                            }
                            this.fileList = []
                            this.videoFileList = []
                        }else {
                            this.$message.console.error(res.data.messages)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 上架下架
        updateInfomercial(row ,type){
            let title = type == 1?'是否确认上架?':'是否确认下架?'
            this.$confirm(title, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                let formData = new FormData()
                formData.append('position' , row.position)
                formData.append('type' ,row.type)
                formData.append('link' ,row.link)
                formData.append('num' ,row.num)
                formData.append('remark' ,row.remark)
                formData.append('status' ,type)
                formData.append('linkType' ,row.linkType)
                formData.append('fatherId' ,row.fatherId)
                formData.append('id' ,row.id)
                this.$axios({
                    method: "POST",
                    url: "/yunyue-houtai/admin/updateInfomercial",
                    headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                    },
                    data: formData,
                }).then(res => {
                        if (res.data.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.data.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消！'
                })
            })
        },
        // 删除
        delInfomercial(index , row){
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                delInfomercial({
                    id :row.id,
                }).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.messages
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        handleChange(file){
            console.log(file)
            this.fileList = [file.file] 
            console.log(this.fileList)
        },
        videoHandleChange(file){
            console.log(file)
            this.videoFileList = [file.file] 
            console.log(this.videoFileList)
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
            this.fileList = []
            this.videoFileList = []
            this.editForm = {
                type:"",
                status:'1',
                fatherId:'',
                barflag:2
            }
        },
        tabChange(){
            console.log(41321321)
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadInfomercialList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                position:7,
                type:this.tabPosition
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .img_inner{
    transform: all .3s;
    cursor: pointer;
  }
  .img_inner:hover{
    transform: scale(1.2);
  }
</style>


// WEBPACK FOOTER //
// src/views/AdvertisingManagement/cashier/cashierPc.vue